import { Subtitle2, useTheme } from '@backoffice-frontend/patterns'
import { ErrorCircleIcon } from '@moia-dev/pace-icons'
import { LoadingIndicator } from '@moia-dev/pace-web'
import { useTranslation } from 'react-i18next'
import type {
  ServiceCancellationDecision,
  ServiceCancellationMachineState,
} from '../../../ServiceCancellation/ServiceCancellationProvider'

export const ServiceCancellationCheck = ({
  serviceCancellationState,
  decision,
}: {
  serviceCancellationState: ServiceCancellationMachineState
  decision?: ServiceCancellationDecision
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const renderIconAndText = () => {
    if (serviceCancellationState.matches('confirmed')) {
      return (
        <>
          <LoadingIndicator size={24} />
          <Subtitle2
            css={{
              color: theme.semantic.ColorContentReduced,
              marginLeft: theme.space.Space2,
            }}
          >
            {decision === 'cancelAllTrips'
              ? t('adFleetMap_serviceCancellationRequested_label')
              : t('adFleetMap_continueTripsProcessing_label')}
          </Subtitle2>
        </>
      )
    }
    if (serviceCancellationState.matches({ completed: 'error' })) {
      return (
        <>
          <ErrorCircleIcon color={theme.semantic.ColorCriticalDefault} />
          <Subtitle2
            css={{
              color: theme.semantic.ColorCriticalDefault,
              marginLeft: theme.space.Space2,
            }}
          >
            {t('adFleetMap_serviceCancellationFailed_label')}
          </Subtitle2>
        </>
      )
    }
    return <div css={{ height: '24px' }} />
  }

  return (
    <div
      css={theme => ({
        display: 'flex',
        alignItems: 'center',
        color: serviceCancellationState.matches('confirmed')
          ? theme.semantic.ColorContentReduced
          : theme.semantic.ColorContentDefault,
        marginLeft: theme.space.Space4,
      })}
    >
      {renderIconAndText()}
    </div>
  )
}
